import styled from 'styled-components';
import color from 'color';
import theme from 'styles/theme';
import Link from 'modules/Link';

const common = (colors) => `
  background-color: ${colors.blue};
  padding: 7px 15px;
  color: ${color(colors.blue).isDark() ? '#fff' : '#000'};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.27px;
  text-decoration: none;
  border-radius: 4px;
  border: 1px solid ${colors.blue};
  cursor: pointer;
  transition: ${theme.transition};

  &:hover,
  &:focus {
    color: ${color(colors.blue).isDark() ? '#fff' : '#000'};
    background-color: ${colors.blueHover};
    border-color: ${colors.blueHover};
  }

  svg {
    vertical-align: middle;
  }
`;

const inverted = (colors) => `
  color: ${colors.blue};
  background-color: #ffffff;
  border-color: #ffffff;

  &:hover,
  &:focus {
    color: ${colors.blue};
    background-color: ${colors.lightGrey};
    border-color: #ffffff;
  }
`;

const darkened = (colors) => `
  background-color: ${colors.black};
  color: #ffffff;
  border-color: ${colors.black};
`;

const yellowed = (colors) => `
  color: ${colors.black};
  background-color: ${colors.yellow};
  border-color: ${colors.yellow};

  &:hover,
  &:focus {
    color: ${theme.colors.black};
    background-color: ${theme.colors.yellowHover};
    border-color: ${theme.colors.yellowHover};
  }
`;

const greyed = (colors) => `
  color: ${colors.black};
  background-color: ${colors.lightGrey};
  border-color: ${colors.lightGrey};

  &:hover,
  &:focus {
    color: ${colors.black};
    background-color: #ffffff;
    border-color: ${colors.black};
  }
`;

const border = (colors) => `
  color: ${colors.black};
  background-color: #ffffff;
  border: 1px solid ${colors.deepLightGrey};

  &:hover,
  &:focus {
    color: ${colors.black};
    background-color: #ffffff;
    border: 1px solid ${colors.black};
  }
`;

const tealed = (colors) => `
  color: #ffffff;
  background-color: ${colors.teal};
  border-color: ${colors.teal};

  &:hover,
  &:focus {
    color: #ffffff;
    background-color: ${colors.teal};
    border-color: ${colors.teal};
    filter: brightness(0.95);
  }
`;

export const SubmitButton = styled.button`
  ${({ theme: { colors } }) => common(colors)}
  ${({ invert, theme: { colors } }) => invert && inverted(colors)}
  ${({ dark, theme: { colors } }) => dark && darkened(colors)}
  ${({ yellow, theme: { colors } }) => yellow && yellowed(colors)}
  ${({ grey, theme: { colors } }) => grey && greyed(colors)}
  ${({ bordered, theme: { colors } }) => bordered && border(colors)}
  ${({ rounded }) => rounded && `border-radius: 50px;`}
  ${({ teal, theme: { colors } }) => teal && tealed(colors)}
  ${({ fluid }) =>
    fluid &&
    `
    width: 100%;
  `}

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme: { colors } }) => colors.lightGrey};
    border-color: ${({ theme: { colors } }) => colors.lightGrey};
    color: ${({ theme: { colors } }) => colors.deepLightGrey};
  }
`;

export const AnchorButton = styled(Link)`
  ${({ theme: { colors } }) => common(colors)}
  ${({ theme: { colors } }) => common(colors)}
  ${({ invert, theme: { colors } }) => invert && inverted(colors)}
  ${({ dark, theme: { colors } }) => dark && darkened(colors)}
  ${({ yellow, theme: { colors } }) => yellow && yellowed(colors)}
  ${({ grey, theme: { colors } }) => grey && greyed(colors)}
  ${({ teal, theme: { colors } }) => teal && tealed(colors)}
  ${({ bordered, theme: { colors } }) => bordered && border(colors)}
  display: inline-block;

  ${({ fluid }) =>
    fluid &&
    `
    width: 100%;
  `}

  &:disabled {
    background-color: ${({ theme: { colors } }) => colors.lightGrey};
    border-color: ${({ theme: { colors } }) => colors.lightGrey};
  }
`;

export const UnstyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
`;
